import { calendarDate } from '../../utils/date-time';
import { api } from '../../AxiosConfig';

class AtendentesService {
    create(data: any) {
        return api.post('users/atendentes/create', data);
    }

    getAll() {
        return api.get('users/atendentes/getAll');
    }

    getByEstabId(estabId: string, serviceId?: string) {
        const resolvedServiceId = serviceId ? encodeURIComponent(serviceId) : '__all__';
        return api.get(`users/atendentes/getByEstabId/${estabId}/${resolvedServiceId}`);
    }

    delete(uid: string) {
        return api.post('users/atendentes/delete', { uid });
    }

    update(uid: string, update: {
        admin?: string,
        comissao: number,
        photoURL?: string | null,
    }) {
        return api.post('users/atendentes/update', { uid, update });
    }

    updateAgenda(atendenteId: string, update: any) {
        return api.post('users/atendentes/updateAgenda', { atendenteId, update });
    }

    getAgenda(atendenteId: string) {
        return api.get(`users/atendentes/agenda/${atendenteId}`);
    }


    addClosedSlots({ atendenteId, date, closedSlots }: {
        date: string
        atendenteId: string,
        closedSlots: { start: number; end: number },
    }) {
        return api.post('users/atendentes/addClosedSlots', { atendenteId, date: calendarDate(date), closedSlots });
    }

    updateAgendaDate({ atendenteId, date, update }: { atendenteId: string; date: string; update: any }) {
        return api.post('users/atendentes/updateAgendaDate', { atendenteId, date: calendarDate(date), update });
    }

    getAgendaDate(atendenteId: string, date: string, estab?: string) {
        return api.get(`users/atendentes/agendaDate/${atendenteId}/${calendarDate(date)}/${estab}`);
    }

    getAgendaList(atendenteId: string, date: string) {
        return api.get(`users/atendentes/agendaList/${atendenteId}/${calendarDate(date)}`);
    }
}

export { AtendentesService };
